import type { GivingDetail } from 'models';
import { Card, CollapsibleCard, DocumentLineIcon, RichTextRenderer } from 'ui';
import { useUser } from 'features/auth';
import { Translation } from 'features/translations';

type P = {
  giving: GivingDetail;
};

const DescriptionCard = ({ giving }: P) => {
  const user = useUser({ requiredAuth: false });

  return (
    <>
      {user ? (
        <CollapsibleCard card={{ title: <Card.Title icon={<DocumentLineIcon />}>Description</Card.Title> }}>
          <RichTextRenderer data={giving.htmlDescription} />
          <Translation id={giving.id} type="giving" />
        </CollapsibleCard>
      ) : (
        <Card title="Description">
          <RichTextRenderer data={giving.htmlDescription} />
        </Card>
      )}
    </>
  );
};

export default DescriptionCard;
